const hoursOftheDay = suffix => {
  const hours = [...Array(23)].map((_, i) => i > 8 ? `${i + 1}:${suffix}` : `0${i + 1}:${suffix}`)
  hours.unshift(`00:${suffix}`)
  return hours
}

export default hoursOftheDay
